module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_intro_sp-f45b6b45ea14984df8bb674c42fe6bb8.png";